import {
	type FC,
	type ReactNode,
	createContext,
	useCallback,
	useContext,
	useState,
} from "react";

interface SidebarContextValue {
	mobileOpen: boolean;
	openMobileSidebar: () => void;
	closeMobileSidebar: () => void;
	toggleMobileSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextValue | null>(null);

export const SidebarProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const [mobileOpen, setMobileOpen] = useState(false);

	const openMobileSidebar = useCallback(() => setMobileOpen(true), []);
	const closeMobileSidebar = useCallback(() => setMobileOpen(false), []);
	const toggleMobileSidebar = useCallback(() => setMobileOpen((v) => !v), []);

	const value: SidebarContextValue = {
		mobileOpen,
		openMobileSidebar,
		closeMobileSidebar,
		toggleMobileSidebar,
	};

	return (
		<SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
	);
};

export function useSidebarContext(): SidebarContextValue {
	const ctx = useContext(SidebarContext);
	if (!ctx) {
		throw new Error("useSidebarContext must be used within SidebarProvider");
	}
	return ctx;
}
